import AppliedToMyInstitution from './AppliedToMyInstitution';

export default AppliedToMyInstitution;
